export enum SubscriptionsStatus {
    ACTIVE= "active",
    CANCELED= 'canceled',
    INCOMPLETE='incomplete',
    INCOMPLETE_EXPIRED="incomplete_expired",
    PAST_DUE="past_due",
    TRIALING="trialing",
    UNPAID="unpaid",
}